

























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import store from '@app/store';

@Component({
  name: 'bpc-header-user-area',
  components: {},
})
export default class Header extends Vue {
  @Prop({ type: String, default: 'public' }) readonly layout: string;

  get isPublicLayout(): boolean {
    return this.layout == 'public';
  }

  get countUnreadMessages() {
    return this.$store.getters['message/unreadMessages'].length;
  }

  get tenantAlias(): string {
    const tenant = this.$authService.getSelectedTenant();
    return tenant.alias || 't';
  }

  get tenantAliasParams() {
    return {
      tenantAlias: this.tenantAlias,
    };
  }

  get tenantType() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].center_type
      : 'center';
  }

  get profileMailboxRoute() {
    const adminMailboxRoute = this.tenantType === 'club' ? 'admin-club-messages' : 'admin-mailbox';
    const routeName = this.isPublicLayout ? 'profile-mailbox' : adminMailboxRoute;
    return {
      name: routeName,
      params: this.tenantAliasParams,
    };
  }

  mounted() {
    const isLoggedIn = store.getters['auth/isLoggedIn'];
    if (isLoggedIn) {
      this.$store.dispatch('message/getMessages');
    }
  }
}
